/**
 * TanStack Query hooks for `regional-data-residency-india-eu-us`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	regionalDataResidencyIndiaEuUsQueryKeys,
	type CreateRegionalDataResidencyIndiaEuUsBody,
	type ListRegionalDataResidencyIndiaEuUsResponse,
	type RegionalDataResidencyIndiaEuUsRow,
} from "./api";

export function useRegionalDataResidencyIndiaEuUsList(): UseQueryResult<ListRegionalDataResidencyIndiaEuUsResponse, Error> {
	return useQuery({
		queryKey: regionalDataResidencyIndiaEuUsQueryKeys.list(),
		queryFn: list,
	});
}

export function useRegionalDataResidencyIndiaEuUsCreate(): UseMutationResult<RegionalDataResidencyIndiaEuUsRow, Error, CreateRegionalDataResidencyIndiaEuUsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: regionalDataResidencyIndiaEuUsQueryKeys.all });
		},
	});
}

export function useRegionalDataResidencyIndiaEuUsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: regionalDataResidencyIndiaEuUsQueryKeys.all });
		},
	});
}
